import React from "react";
import cn from "classnames";

const fetchImage = src =>
  new Promise((res, rej) => {
    const image = new window.Image();
    image.src = src;
    image.onload = res;
    image.onabort = rej;
    image.onerror = rej;
  });

const IntrinsicPlaceholder = ({ aspectRatio, children, ...other }) => {
  const placeholder = {
    paddingTop: `${aspectRatio}%`
  };
  return (
    <div
      className="w-full overflow-hidden relative"
      style={placeholder}
      {...other}
    >
      {children}
    </div>
  );
};

const ImageContainer = ({
  bgColor = "grey-lighter",
  isStillLoading,
  children
}) => (
  <div
    className={cn(
      "w-full",
      "h-full",
      "absoulte",
      isStillLoading && `bg-${bgColor}`,
      "pin-t",
      "pin-l"
    )}
  >
    {children}
  </div>
);

const Image = ({
  src,
  fadeInDuration = 0.5,
  isVisible = false,
  backgroundPositioningStyles
}) => (
  <div
    className="w-full h-full absolute pin-l pin-t"
    style={{
      backgroundImage: `url(${src})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "50% 50%",
      transition: `opacity ${fadeInDuration}s linear`,
      opacity: `${isVisible ? 1 : 0}`,
      ...backgroundPositioningStyles
    }}
  />
);

export default class LazyImage extends React.Component {
  constructor() {
    super();

    this.state = {
      status: null,
      thumb: null
    };

    this._isMounted = false;
  }

  preload() {
    const { src, thumbnail } = this.props;
    if (thumbnail)
      fetchImage(thumbnail)
        .then(() => this.onImageLoaded("thumb"))
        .catch(() => this.onImageError("thumb"));

    fetchImage(src)
      .then(() => this.onImageLoaded("status"))
      .catch(() => this.onImageError("status"));
  }

  onImageError(image) {
    if (!this._isMounted) return;
    this.setState({
      [image]: "error"
    });
  }

  onImageLoaded(image) {
    if (!this._isMounted) return;
    this.setState({
      [image]: "loaded"
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.preload();
  }

  render() {
    const {
      src,
      aspectRatio,
      thumbnail,
      fallback: Fallback,
      bgColor,
      fadeInDuration
    } = this.props;
    const { status } = this.state;

    return (
      <IntrinsicPlaceholder aspectRatio={aspectRatio}>
        <ImageContainer bgColor={bgColor} isStillLoading={status === null}>
          {status !== "loaded" &&
            thumbnail && (
              <img
                src={thumbnail}
                width="100%"
                height="100%"
                style={{ filter: "blur(25px)" }}
              />
            )}
          <Image
            src={src}
            fadeInDuration={fadeInDuration}
            isVisible={status === "loaded"}
          />
          {status === "error" && ((Fallback && <Fallback />) || null)}
        </ImageContainer>
      </IntrinsicPlaceholder>
    );
  }
}



// WEBPACK FOOTER //
// ./src/LazyImage/LazyImage.js